import React from "react";
import { Cell, Pie, PieChart, Tooltip } from "recharts";

interface Props {
  data: {
    Good?: number;
    Average?: number;
    Bad?: number;
  };
}

const LIGHT_COLORS = ["#27AE60", "#F2C94C", "#EB5757"];
const DARK_COLORS = ["#1fa86b", "#d3ac62", "#c14449"];

const SatisfactionChart: React.FC<Props> = ({ data }) => {
  const isDark = document.documentElement.getAttribute("data-bs-theme") === "dark";
  const palette = isDark ? DARK_COLORS : LIGHT_COLORS;

  const chartData = [
    { name: "Good", value: data.Good || 0, color: palette[0] },
    { name: "Average", value: data.Average || 0, color: palette[1] },
    { name: "Bad", value: data.Bad || 0, color: palette[2] },
  ];

  return (
    <div className="dark"
      style={{
        backgroundColor: "var(--vz-card-bg, #E8F3EF)",
        borderRadius: 16,
        padding: 16,
        display: "flex",
        flexDirection: "column",
        gap: 12,
        width: 400,
      }}
    >      
    <h3
      className="m-0 text-[18px] fw-semibold"
      style={{ color: "var(--vz-card-color, #111827)" }}
    >
      Satisfaction Breakdown
    </h3>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* Legend */}
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {chartData.map((item) => (
            <div
              key={item.name}
              style={{ display: "flex", alignItems: "center", gap: 8 }}
            >
              <span
                style={{
                  width: 12,
                  height: 14,
                  borderRadius: 4,
                  backgroundColor: item.color,
                }}
              />
              <span
                style={{
                  fontSize: 14,
                  color: "var(--vz-card-color, #111827)",
                }}
              >
                {item.name}
              </span>
            </div>
          ))}
        </div>

        {/* Pie chart */}
        <PieChart width={260} height={200}>
          <Pie
            data={chartData}
            cx={140}
            cy={100}
            outerRadius={80}
            dataKey="value"
            labelLine={false}
          >
            {chartData.map((entry, index) => (
              <Cell
                key={entry.name}
                fill={entry.color}
                stroke="#FFFFFF"
                strokeWidth={1}
              />
            ))}
          </Pie>
          <Tooltip />
        </PieChart>
      </div>
    </div>
  );
};

export default SatisfactionChart;
